module.exports = __webpack_public_path__ + "static/media/logo_white.6fa22c5c.svg";